module.exports = __webpack_public_path__ + "img/tabs1(5).90e349f4.png";